export const ROOT = '/';
export const ROOT_ALL = '/*';
export const LOGO = '/logo';
